import "./ButtonComponentStyles.scss";
import { FC, useState } from "react";
import ButtonComponentProps from "./ButtonComponentProps";

const ButtonComponent: FC<ButtonComponentProps> = ({ onClick, text, className, design = "primary", disabled, height, icon, isLoading, style, type = "button", width }) => {
    const [_loading, setLoading] = useState(false);
    const loading = isLoading || _loading;

    const _handleOnClick = async () => {
        setLoading(true);
        await onClick?.();
        setLoading(false);
    }
    return (
        <button className={`button_component ${design} btn ${className}`} style={{
            ...style,
            height,
            width,
        }}
            type={type}
            disabled={loading || disabled} onClick={_handleOnClick}> {
                (icon || loading) && <div className="icon">{!loading ? icon
                    : <div className="spinner-border spinner-border-sm" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                 }</div>
            } 
             {text}</button>
    );
}

export default ButtonComponent;